import { DC } from "../../constants";

const rebuyable = props => {
  props.cost = () => props.initialCost * Math.pow(props.costMult, player.reality.imaginaryRebuyables[props.id]);
  const { effect } = props;
  if (props.isDecimal) props.effect = () => Decimal.pow(effect, player.reality.imaginaryRebuyables[props.id]);
  else props.effect = () => effect * player.reality.imaginaryRebuyables[props.id];
  if (!props.formatEffect) props.formatEffect = value => `+${format(value, 2, 2)}`;
  props.formatCost = value => format(value, 2, 0);
  return props;
};

export const imaginaryUpgrades = [
  rebuyable({
    name: "Темпоральный Интенсификатор",
    id: 1,
    initialCost: 3,
    costMult: 60,
    description: () => `Умеличить множитель Темпорального Усилителя на +${format(0.15, 2, 2)}`,
    effect: 0.15
  }),
  rebuyable({
    name: "Репликативный Интенсификатор",
    id: 2,
    initialCost: 4,
    costMult: 60,
    description: () => `Увеличить множитель Репликативного Усилителя на +${format(0.15, 2, 2)}`,
    effect: 0.15
  }),
  rebuyable({
    name: "Вечный Интенсификатор",
    id: 3,
    initialCost: 1,
    costMult: 40,
    description: () => `Увеличить множитель Вечного Усилителя на +${format(0.4, 2, 2)}`,
    effect: 0.4
  }),
  rebuyable({
    name: "Свехсветовой Интенсификатор",
    id: 4,
    initialCost: 5,
    costMult: 80,
    description: () => `Увеличить множитель Сверхсветового Усилителя на +${format(0.15, 2, 2)}`,
    effect: 0.15
  }),
  rebuyable({
    name: "Безграничный Интенсификатор",
    id: 5,
    initialCost: 1,
    costMult: 30,
    description: () => `Увеличить множитель Безграничного Усилителя на +${format(0.6, 2, 2)}`,
    effect: 0.6
  }),
  rebuyable({
    name: "Эллиптическая Существенность",
    id: 6,
    initialCost: 1e4,
    costMult: 500,
    description: () => `Повысить ограничение Машин Реальности на ${formatX(1e100)}`,
    effect: 1e100,
    formatEffect: value => `${formatX(value)}`,
    isDecimal: true
  }),
  rebuyable({
    name: "Руническая Гарантия",
    id: 7,
    initialCost: 2e5,
    costMult: 500,
    description: () => `Отложить Уровень начала Нестабильности Глифов на ${formatInt(200)}`,
    effect: 200,
    formatEffect: value => `+${formatInt(value)} уровней`
  }),
  rebuyable({
    name: "Гиперболический Апейрогон",
    id: 8,
    initialCost: 1e7,
    costMult: 800,
    description: () => `Умножить Измерения Бесконечности на ${format("1e100000")}`,
    effect: DC.E100000,
    formatEffect: value => `${formatX(value)}`,
    isDecimal: true
  }),
  rebuyable({
    name: "Космическая Нить",
    id: 9,
    initialCost: 1e9,
    costMult: 1000,
    description: () => `Увеличить Силу Галактик`,
    effect: 0.03,
    formatEffect: value => `+${formatPercents(value)}`,
  }),
  rebuyable({
    name: "Энтропийное Сгущение",
    id: 10,
    initialCost: 8e9,
    costMult: 2000,
    description: () => `Увеличить заработок Сингулярностей`,
    effect: 1,
    formatEffect: value => `${formatX(1 + value, 2)}`
  }),
  {
    name: "Подозрение Вторжения",
    id: 11,
    cost: 5e7,
    requirement: () => `${format(1e90)} всего Осколков Реликвий
      (Вы имеете ${format(player.celestials.effarig.relicShards, 2)})`,
    hasFailed: () => false,
    checkRequirement: () => player.celestials.effarig.relicShards >= 1e90,
    checkEvent: GAME_EVENT.REALITY_RESET_AFTER,
    description: "Степень Измерений Времени, основанная на общем количестве антиматерии",
    effect: () => 1 + Math.log10(player.records.totalAntimatter.log10()) / 100,
    formatEffect: value => `${formatPow(value, 0, 4)}`,
    isDisabledInDoomed: true
  },
  {
    name: "Последствия Иллюзий",
    id: 12,
    cost: 5e7,
    requirement: () => `Сделайте Глиф уровня ${formatInt(9000)} с одним коэффициентом веса на
    ${formatInt(100)}`,
    hasFailed: () => false,
    checkRequirement: () => Object.values(player.celestials.effarig.glyphWeights).some(w => w === 100) &&
      gainedGlyphLevel().actualLevel >= 9000,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    description: "Получите бесплатные Бусты Измерений на основе количества многоразовых Мнимых Улучшений",
    effect: () => 2e4 * ImaginaryUpgrades.totalRebuyables,
    formatEffect: value => `${format(value, 1)}`,
    isDisabledInDoomed: true
  },
  {
    name: "Быстротечность информации",
    id: 13,
    cost: 5e7,
    requirement: () => `Достигните ${format(Number.MAX_VALUE, 2)} предполагаемых Машин Реальности внутри
      Реальности Безымянных`,
    hasFailed: () => !Enslaved.isRunning,
    // This is for consistency with the UI, which displays an amplified "projected RM" value on the reality button
    checkRequirement: () => Enslaved.isRunning &&
      MachineHandler.uncappedRM.times(simulatedRealityCount(false) + 1).gte(Number.MAX_VALUE),
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    description: "Увеличение Ограничения Мнимых Машин, основанное на купленных Мнимых Улучшениях",
    effect: () => 1 + ImaginaryUpgrades.totalRebuyables / 20 + ImaginaryUpgrades.totalSinglePurchase / 2,
    formatEffect: value => `${formatX(value, 2, 1)}`,
    isDisabledInDoomed: true
  },
  {
    name: "Вспоминание Вторжения",
    id: 14,
    cost: 3.5e8,
    formatCost: x => format(x, 1),
    requirement: () => `Достигните скорости тика в ${format("1e75000000000")} / сек внутри Вечного Челленджа 5`,
    hasFailed: () => false,
    checkRequirement: () => EternityChallenge(5).isRunning && Tickspeed.perSecond.exponent >= 7.5e10,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    description: () => `Поднимает все множители Измерений за покупку на ${formatPow(1.5, 0, 1)}`,
    effect: 1.5,
    isDisabledInDoomed: true
  },
  {
    name: "Фабрикация Идеалов",
    id: 15,
    cost: 1e9,
    requirement: () => `Достигните ${format("1e1500000000000")} антиматерии без
      использования 1ых Измерений Бесконечности когда-либо`,
    hasFailed: () => player.requirementChecks.reality.maxID1.gt(0),
    checkRequirement: () => player.requirementChecks.reality.maxID1.eq(0) && player.antimatter.exponent >= 1.5e12,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    canLock: true,
    // This upgrade lock acts in multiple different conditions, but isn't 100% foolproof and also blocks a few edge
    // cases which technically should be allowed but would be hard to communicate in-game. Forbidden actions are:
    // - Purchasing any ID (edge case: this is acceptable for ID2-8 inside EC2 or EC10)
    // - Purchasing any TD with any amount of EC7 completions (edge case: acceptable within EC1 or EC10)
    // - Entering EC7 with any amount of purchased TD
    description: () => `${
      Pelle.isDoomed ? "Разблокировать" : "Конвертировать Измерения Антиматерии в Континуум и разблокировать"
    } Лай'телу, Божество Измерений`,
  },
  {
    name: "Безмассовый Импульс",
    id: 16,
    cost: 3.5e9,
    formatCost: x => format(x, 1),
    requirement: () => `Дестабилизируйте Реальность Лай'телы за ${formatInt(30)} секунд дважды`,
    hasFailed: () => false,
    checkRequirement: () => Laitela.maxAllowedDimension <= 6,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    description: "Разблокирует 2ые Измерения Тёмной Материи",
  },
  {
    name: "Киральное колебание",
    id: 17,
    cost: 6e9,
    requirement: () => `Автоматически уплотните как минимум ${formatInt(20)} Сингулярностей за раз`,
    hasFailed: () => false,
    checkRequirement: () => Singularity.singularitiesGained >= 20 &&
      Currency.darkEnergy.gte(Singularity.cap * SingularityMilestone.autoCondense.effectOrDefault(Infinity)),
    checkEvent: GAME_EVENT.SINGULARITY_RESET_BEFORE,
    description: "Разблокирует 3е Измерение Тёмной Материи",
  },
  {
    name: "Пространственная Симметрия",
    id: 18,
    cost: 1.5e10,
    formatCost: x => format(x, 1),
    requirement: () => `Имейте ${formatInt(80000)} Галактик всего`,
    hasFailed: () => false,
    checkRequirement: () => Replicanti.galaxies.total + player.galaxies +
      player.dilation.totalTachyonGalaxies >= 80000,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    description: "Разблокируйте 4ые Измерения Тёмной Материи",
  },
  {
    name: "Детерминистское излучение",
    id: 19,
    cost: 2.8e10,
    formatCost: x => format(x, 1),
    requirement: () => `Достигните ${formatInt(3.85e6)} Скорости Тика Континуума без использования более чем
      ${formatInt(8)} Временны́х Исследований в этой Реальности`,
    hasFailed: () => player.requirementChecks.reality.maxStudies > 8,
    checkRequirement: () => player.requirementChecks.reality.maxStudies <= 8 &&
      Tickspeed.continuumValue >= 3.85e6,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    canLock: true,
    lockEvent: () => `купить более чем ${formatInt(8)} Временны́х Исследований`,
    description: "Разблокируйте Аннигиляцию Тёмной Материи"
  },
  {
    name: "Вакуумное Ускорение",
    id: 20,
    cost: 3e12,
    requirement: () => `Получите увеличение Континуума как минимум на ${formatPercents(1)}`,
    hasFailed: () => false,
    checkRequirement: () => Laitela.matterExtraPurchaseFactor >= 2,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    description: () => `Разблокирует АвтоПокупщик для повторяемых Мнимых Улучшений и ускоряет генерацию Мнимых Машин в
      ${formatInt(10)} раз`,
    effect: 10,
    isDisabledInDoomed: true
  },
  {
    name: "Экзистенциальное Устранение",
    id: 21,
    cost: 1e13,
    requirement: () => `Достигните ${format("1e7400000000000")} антиматерии с отключенным на протяжении всей 
      Реальности Континуумом`,
    hasFailed: () => !player.requirementChecks.reality.noContinuum,
    checkRequirement: () => player.requirementChecks.reality.noContinuum &&
      Currency.antimatter.value.log10() >= 7.4e12,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    canLock: true,
    lockEvent: "включить Континуум",
    description: "Заработок множителя Аннигиляции улучшен на основе Мнимых Машин",
    effect: () => Math.clampMin(Math.pow(Math.log10(Currency.imaginaryMachines.value) - 10, 3), 1),
    formatEffect: value => `${formatX(value, 2, 1)}`,
    isDisabledInDoomed: true
  },
  {
    name: "Тотальная Терминация",
    id: 22,
    cost: 1.5e14,
    formatCost: x => format(x, 1),
    requirement: () => `Достигните ${format("1e150000000000")} антиматерии в Реальности Эффарига с как минимум
      ${formatInt(4)} экипированными Проклятыми Глифами`,
    // Note: 4 cursed glyphs is -12 glyph count, but equipping a positive glyph in the last slot is allowed
    hasFailed: () => !Effarig.isRunning || player.requirementChecks.reality.maxGlyphs > -10,
    checkRequirement: () => Effarig.isRunning && player.requirementChecks.reality.maxGlyphs < -10 &&
      Currency.antimatter.value.exponent >= 1.5e11,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    description: () => `Всё Жертвование Глифов повышено до ${format(1e100)}`,
    effect: 1e100,
    isDisabledInDoomed: true
  },
  {
    name: "Плоскостное Очищение",
    id: 23,
    cost: 6e14,
    requirement: () => `Достигните Глифа уровня ${formatInt(20000)} в Реальности Ра с максимумом в
      ${formatInt(0)} экипированных Глифов`,
    hasFailed: () => !Ra.isRunning || player.requirementChecks.reality.maxGlyphs > 0,
    checkRequirement: () => Ra.isRunning && player.requirementChecks.reality.maxGlyphs <= 0 &&
      gainedGlyphLevel().actualLevel >= 20000,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    description: "Увеличивает количество бесплатных Бустов Измерений на основе количества Тессерактов",
    effect: () => Math.floor(0.25 * Math.pow(Tesseracts.effectiveCount, 2)),
    formatEffect: value => `${formatX(value)}`,
    isDisabledInDoomed: true
  },
  {
    name: "Абсолютное Аннулирование",
    id: 24,
    cost: 6e14,
    // We unfortunately don't have the UI space to be more descriptive on this button without causing text overflow,
    // so hopefully the additional modals (from the upgrade lock) will mostly communicate the idea that this is under
    // the same conditions as hard V's Post-destination
    requirement: () => `Получите ${formatInt(13000)} Галактик Антиматерии в Реальности Ра
      с полностью инвертированной Чёрной Дырой`,
    hasFailed: () => !Ra.isRunning || player.requirementChecks.reality.slowestBH > 1e-300,
    checkRequirement: () => Ra.isRunning && player.requirementChecks.reality.slowestBH <= 1e-300 &&
      player.galaxies >= 13000,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    canLock: true,
    // Three locking events: uninvert, discharge, and entering (but not auto-completing) EC12
    description: "Повышает силу бесплатных Бустов Измерений на основе количества Сингулярностей",
    effect: () => Decimal.pow(player.celestials.laitela.singularities, 300),
    formatEffect: value => `${formatX(value, 2, 1)}`,
    isDisabledInDoomed: true
  },
  {
    name: "Вездесущее Искоренение",
    id: 25,
    cost: 1.6e15,
    formatCost: x => format(x, 1),
    requirement: () => `Достигните Реальности в Реальности Лай'телы со всеми Измерениями отключенными и как минимум
      ${formatInt(4)} пустыми слотами Глифа`,
    hasFailed: () => !Laitela.isRunning || Laitela.maxAllowedDimension !== 0 ||
      Glyphs.activeWithoutCompanion.length > 1,
    checkRequirement: () => Laitela.isRunning && Laitela.maxAllowedDimension === 0 &&
      Glyphs.activeWithoutCompanion.length <= 1 && TimeStudy.reality.isBought,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    canLock: true,
    lockEvent: "экипировать ещё один не-компаньонский Глиф",
    description: "Разблокирует Пелле, Божество Антиматерии",
  },
];
